import { Card } from "@/components/ui/card";

export const StatCard = ({ label, value, sub, icon: Icon, accent = "primary", testid }) => {
  const accents = {
    primary: "text-primary bg-primary/10",
    success: "text-success bg-success/10",
    warning: "text-warning bg-warning/10",
    secondary: "text-chart-2 bg-chart-2/10",
  };
  return (
    <Card
      data-testid={testid}
      className="p-5 flex items-start justify-between gap-4 hover:border-primary/40 transition-colors animate-fade-up"
    >
      <div className="min-w-0">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</p>
        <p className="mt-2 text-2xl font-bold font-heading tracking-tight truncate">{value}</p>
        {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
      </div>
      {Icon && (
        <div className={`shrink-0 h-10 w-10 rounded-xl grid place-items-center ${accents[accent]}`}>
          <Icon className="h-5 w-5" />
        </div>
      )}
    </Card>
  );
};
